import BudgetPhaseMetaDateTimeRange from "./BudgetPhaseMetaDateTimeRange";
import {
  toScheduledPhaseRangeInput,
  type PhaseCalendarNeighborBounds,
  type ScheduledPhaseRangePickerProps,
} from "./phaseDateTimeRangeModel";

export type { PhaseCalendarNeighborBounds, ScheduledPhaseRangePickerProps };

/**
 * One phased budget row’s schedule range (calendar days, Meta 15m snap).
 * Requires a parent {@link LocalizationProvider}.
 */
export function ScheduledPhaseRangePicker(props: ScheduledPhaseRangePickerProps) {
  return (
    <BudgetPhaseMetaDateTimeRange {...toScheduledPhaseRangeInput(props)} />
  );
}
